<router-outlet></router-outlet>
<!-- toasts -->
<div class="toast-container p3 position-absolute start-50 translate-middle-x" id="toastPlacement">
    <div id="toastMessageModal" role="alert" aria-live="assertive" aria-atomic="true" class="toast" data-bs-autohide="false">
        <div class="toast-body"></div>
    </div>
</div>
